// Imports for external libraries go here.
import React, { FC } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { RichText } from '@marriott/mi-ui-library';

import { LegalTextWithLinkProps } from './LegalTextWithLink.types';
import { StyledLegalTextWithLink } from './LegalTextWithLink.styles';

export const LegalTextWithLink: FC<LegalTextWithLinkProps> = ({ descriptionText, className }) => {
  const textToRender = DOMPurify.sanitize(descriptionText, {
    RETURN_DOM: true,
    ALLOWED_ATTR: ['href', 'target', 'class'],
    ALLOWED_TAGS: ['a', 'span', 'ul', 'li', 'u', 'h5', 'h3', 'strong', 'b'],
  });

  const fragmentString = textToRender.innerHTML;

  return (
    <StyledLegalTextWithLink
      data-component-name="m-legal-LegalTextWithLink"
      data-testid="legal-LegalTextWithLink"
      className={className}
    >
      {descriptionText && (
        <RichText componentId={'descriptionText'} text={fragmentString} customClass="legal-text-link" />
      )}
    </StyledLegalTextWithLink>
  );
};
